import { useAssignee } from "PFApp/hooks/activity_commons/participants/use_assignee";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Label } from "../parts/label";

type AssigneeProps = {
  activity: Activity;
};

export const Assignee = ({ activity }: AssigneeProps) => {
  const { t } = useTranslation("translation");
  const { assignee, canView } = useAssignee(activity);

  if (!canView) {
    return null;
  }

  return (
    <Stack>
      <Label text={t("assignee")} />
      <Link to={`/profiles/${assignee!.id}`}>
        <Typography variant="bodyBold" tag="span">
          {getProfileName(assignee!)}
        </Typography>
      </Link>
    </Stack>
  );
};
